import React from "react";
import { useEffect, useState } from "react";
import DashboardCard from "../../../components/DashboardCard";
import MyFiles from "../../../assets/images/MyFiles.svg";
import { useHistory } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { IdentificationIcon } from "@heroicons/react/24/solid";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { PERMISSIONS } from "../../PermissionsConstants";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import {
  mainSelectedTab,
  permittedTabs,
} from "../../CarrierAgreementMgmt/atoms";
import { RedirectTo } from "../../../routes/RedirectTo";
import { useBusLicensePermitCount } from "modules/CarrierAgreementMgmt/BusinessLicensesAndPermits/hooks/useBusLicensePermitCount";

const NewBusinessLicensesCard = () => {
  const [caCount, setCACount] = useState("...");
  const modulePermission = PERMISSIONS.permission_buslicensesandpermits_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  const useraccount = useRecoilValue(accountAtom);

  const history = useHistory();
  const [connection, setConnection] = useState<any>(null);

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [usersTabs] = useRecoilState(permittedTabs);
  const { data: busLicensePermits } = useBusLicensePermitCount();

  const busLicensePermitsCount = busLicensePermits?.total;

  return (
    <div
      className="p-2 pr-4 bg-white text-primary rounded-lg animate-fade-in-down2 shadow-md hover:text-white hover:bg-purpleBG"
      onClick={() => {
        if (userPermissions.includes(modulePermission)) {
          const urlPath = "/officesettings/buslicensesandpermits";
          history.push({
            pathname: urlPath,
          });
        }
      }}
    >
      <DashboardCard
        text="Business Licenses"
        count={busLicensePermitsCount}
        image={
          <IdentificationIcon className="text-white bg-purpleBG rounded-md h-7 w-7 p-1" />
        }
        hasAccess={userPermissions.includes(modulePermission)}
      />
    </div>
  );
};

export default NewBusinessLicensesCard;
